export const ABOUT_US = {
  heading: "About Honeywell Digital Prime Twin",
  version: "Version R121.1",
  pat: "Pat.: honpat.com",
  copyright:
    "Copyright 2025, Honeywell International Inc., All rights reserved",
  end_user: "End User License Agreement",
};
